/**
 * Вертикальная прокрутка контента — в `PageShell` (default), а не в `window`.
 * Сохранение позиции списка обращений должно читать/писать этот элемент.
 */

const SCROLL_ROOT_SELECTOR = '[data-app-scroll-root="true"]'

let mainScrollEl: HTMLElement | null = null

export function setMainScrollElement(el: HTMLElement | null) {
  mainScrollEl = el
}

export function getMainScrollElement(): HTMLElement | null {
  if (mainScrollEl && mainScrollEl.isConnected) return mainScrollEl
  if (typeof document !== 'undefined') {
    const q = document.querySelector(SCROLL_ROOT_SELECTOR) as HTMLElement | null
    if (q && q.isConnected) return q
  }
  return null
}

export function getMainScrollTop(): number {
  const el = getMainScrollElement()
  if (el) return el.scrollTop
  if (typeof window !== 'undefined') return window.scrollY
  return 0
}

/** Для сохранения: `PageShell` или `window`, что больше (редкий fallback). */
export function getBestScrollTop(): number {
  const main = getMainScrollTop()
  const win = typeof window !== 'undefined' ? window.scrollY : 0
  return Math.max(main, win)
}

export function setMainScrollTop(y: number) {
  const el = getMainScrollElement()
  if (el) {
    el.scrollTop = y
  } else if (typeof window !== 'undefined') {
    window.scrollTo(0, y)
  }
}
